import { format, parseISO } from 'date-fns'
export const UnassignedColumns = [
  {
    field: 'created_datetime',
    headerName: 'Created On',
    width: 150,
    headerClassName: 'super-app-theme--header',
    valueGetter: (param) => `${format(parseISO(param.row.created_datetime + ''), 'yyyy-MM-dd')}`,
  },
  {
    field: 'case_number',
    headerName: 'TRF ID',
    width: 135,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'state',
    headerName: 'State',
    width: 100,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'patient_first_name',
    headerName: 'Patient Name',
    width: 200,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.patient_last_name || ''}, ${params.row.patient_first_name || ''}`,
  },
  {
    field: 'stat_flag',
    headerName: 'Priority',
    width: 200,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => {
      if (params.row.stat_flag) {
        return 'HIGH'
      } else return 'Standard'
    },
  },
]

export const AssignedColumns = [
  {
    field: 'created_datetime',
    headerName: 'Assigned On',
    width: 120,
    headerClassName: 'super-app-theme--header',
    valueGetter: (param) => `${format(parseISO(param.row.created_datetime + ''), 'yyyy-MM-dd')}`,
  },
  {
    field: 'case_number',
    headerName: 'TRF ID',
    width: 100,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'state',
    headerName: 'State',
    width: 90,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'patient_first_name',
    headerName: 'Patient Name',
    width: 183,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.patient_last_name || ''}, ${params.row.patient_first_name || ''}`,
  },
  {
    field: 'first_name',
    headerName: 'Assigned To',
    width: 175,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.first_name || ''} ${params.row.last_name || ''}`,
  },
  {
    field: 'stat_flag',
    headerName: 'Priority',
    width: 120,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => {
      if (params.row.stat_flag) {
        return 'HIGH'
      } else return 'Standard'
    },
  },
]

export const QCCasesColumns = [
  {
    field: 'created_datetime',
    headerName: 'Assigned On',
    width: 130,
    headerClassName: 'super-app-theme--header',
    valueGetter: (param) => `${format(parseISO(param.row.created_datetime + ''), 'yyyy-MM-dd')}`,
  },
  {
    field: 'case_number',
    headerName: 'TRF ID',
    width: 100,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'state',
    headerName: 'State',
    width: 85,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'patient_first_name',
    headerName: 'Patient Name',
    width: 185,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.patient_last_name || ''}, ${params.row.patient_first_name || ''}`,
  },
  {
    field: 'stat_flag',
    headerName: 'Priority',
    width: 130,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => {
      if (params.row.stat_flag) {
        return 'HIGH'
      } else return 'Standard'
    },
  },

  {
    field: 'first_name',
    headerName: 'Assigned To',
    width: 179,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.first_name || ''} ${params.row.last_name || ''}`,
  },
]

export const LMComplete = [
  {
    field: 'updated_datetime',
    headerName: 'Time of Release',
    width: 165,
    headerClassName: 'super-app-theme--header',
    valueGetter: (param) => `${format(parseISO(param.row.updated_datetime + ''), 'yyyy-MM-dd HH:mm:ss')}`,
  },
  {
    field: 'case_number',
    headerName: 'TRF ID',
    width: 95,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'state',
    headerName: 'State',
    width: 95,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'patient_first_name',
    headerName: 'Patient Name',
    width: 184,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.patient_last_name || ''}, ${params.row.patient_first_name || ''}`,
  },
  {
    field: 'first_name',
    headerName: 'Signature',
    width: 130,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.first_name || ''}, ${params.row.last_name || ''}`,
  },
  {
    field: 'outcome',
    headerName: 'Result',
    width: 118,
    headerClassName: 'super-app-theme--header',
  },
]
